import { useEffect, useState } from 'react';

import { log } from 'utils/logging';
import { getRecommendedActions } from 'utils/search/getRecommendedActions';

/*
 * Fetch recommended actions
 */
export const useRecommendedActions = (
  searchLocation: Pick<SearchLocation, 'latitude' | 'longitude'>
) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    getRecommendedActions(searchLocation, { distinct: true })
      .then((hits) => setData(hits))
      .catch((e) => {
        setError(e);
        log.error(e);
      })
      .finally(() => setIsLoading(false));
  }, [searchLocation]);

  return { data, isLoading, error };
};
